import { createReducer } from '@reduxjs/toolkit'

import * as myScopesActions from '../../actions/MyScopes/actions'
import * as authenticationActions from '../../actions/Authentication/actions'

export interface IMyScopeReducerType {
  data: string[]
  fetched: boolean
  updating: boolean
}

const INITIAL_STATE: IMyScopeReducerType = {
  data: [],
  fetched: false,
  updating: false
}

const myScopeReducer = createReducer(INITIAL_STATE, (builder) => {
  builder
    .addCase(myScopesActions.getAll, (state) => {
      return {
        ...state,
        fetched: false
      }
    })
    .addCase(myScopesActions.getAllSuccess, (state, action) => {
      return {
        ...state,
        data: action.payload,
        fetched: true
      }
    })
    .addCase(myScopesActions.getAllFailed, (state) => {
      return {
        ...state,
        fetched: true
      }
    })
    .addCase(myScopesActions.update, (state) => {
      return {
        ...state,
        updating: true
      }
    })
    .addCase(myScopesActions.updateSuccess, (state, action) => {
      return {
        ...state,
        data: action.payload,
        updating: false,
        fetched: true
      }
    })
    .addCase(myScopesActions.updateFailed, (state) => {
      return {
        ...state,
        updating: false
      }
    })
    .addCase(authenticationActions.signOut, () => INITIAL_STATE)
    .addDefaultCase((state) => state)
})

export default myScopeReducer
